import { Button, Div, H3, Modal, P } from '@vgrubs/components';

type Props = {
  isOpen: boolean;
  /** "Wings on Wingz: delivery $10.00 → $15.00, pickup stays $10.00". */
  change: string;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/**
 * The last look before a price goes live: old and new, both prices, in one
 * line. Laid out like every admin are-you-sure dialog - no header bar.
 */
export const ApproveMenuPriceModal = ({
  isOpen,
  change,
  busy,
  onConfirm,
  onClose,
}: Props) => (
  <Modal isOpen={isOpen} closeModal={onClose} logo={false} exitButton={false}>
    <H3 $m="0 0 10px 0" $center>
      Approve new price?
    </H3>
    <P $m="0 0 8px 0" $center>
      {change}
    </P>
    <P $m="0 0 24px 0" $center>
      The menu is updated right away. The ticket stays open and nothing is sent
      to the merchant.
    </P>

    <Div $flex $gap="16px">
      <Button $selected $w="100%" $loading={busy} onClick={onConfirm}>
        Approve
      </Button>
      <Button $selected $gray $w="100%" disabled={busy} onClick={onClose}>
        Cancel
      </Button>
    </Div>
  </Modal>
);
